import React from "react";
import { Box } from "@mui/material";

const LIVE_DOT = "#16498A";
const OFFLINE_DOT = "#9AA0A6";

// Same LIVE / OFFLINE pill used on the Dashboard.
export default function StatusPill({ connected }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        background: "#EDEDED",
        color: "#6b6b6b",
        fontSize: "11px",
        fontWeight: 600,
        px: "11px",
        py: "5px",
        borderRadius: "999px",
        flexShrink: 0,
      }}
    >
      <Box
        component="span"
        sx={{
          width: 6,
          height: 6,
          borderRadius: "50%",
          background: connected ? LIVE_DOT : OFFLINE_DOT,
        }}
      />
      {connected ? "LIVE" : "OFFLINE"}
    </Box>
  );
}
